import { SET_CURRENT_CLIENT_ID, SET_CURRENT_EVENT_ID } from './actionTypes';

export const setCurrentClientID = clientID => ({
	type: SET_CURRENT_CLIENT_ID,
	clientID,
});

export const setCurrentEvent = event_id => ({
	type: SET_CURRENT_EVENT_ID,
	event_id,
});
